import { z } from 'zod';

export const searchOption = {
  THEMA: 'thema',
  VERANSTALTUNG: 'veranstaltung',
} as const;
export const searchOptionSchema = z.enum(searchOption);
export type SearchOption = z.infer<typeof searchOptionSchema>;
